import { atom } from 'nanostores';
import { validateEmail } from '@/lib/validator/validateEmail';
import { makeFormData } from '@/utils/makeFormData';
import { localeStore } from '@/locale';
import { triggeringYandexMetric } from '@/assets/js/yandex-events';
import { triggeringGoogleTagMetric } from '@/assets/js/google-tag-metrics';
import { trackEvent } from '@/utils/analytics';
import appConfig from '@/config';

export class AskFormStore {
  $isOpened = atom(false);

  $name = atom('');

  $email = atom('');

  $question = atom('');

  $isAgree = atom(true);

  $nameError = atom(false);

  $emailError = atom(false);

  $questionError = atom(false);

  $agreeError = atom(false);

  $isLoading = atom(false);

  $submitError = atom('');

  entryPoint = 'homepage_custom_services';

  store;

  constructor(store) {
    this.store = store;
  }

  invokeAnalytics(method) {
    if (appConfig.appEnv === 'production') {
      if (localeStore.lang === 'ru') triggeringYandexMetric[method]();
      triggeringGoogleTagMetric[method]();
    }
  }

  openModal(entryPoint = 'homepage_custom_services') {
    this.entryPoint = entryPoint;
    this.$isOpened.set(true);
    this.store.scrollStore.lock('demo');
    this.invokeAnalytics('openFormQuestion');
    trackEvent('form_open', { form_id: 'question_form', form_entry_point: entryPoint });
  }

  closeModal() {
    this.$isOpened.set(false);
    this.store.scrollStore.unlock('demo');
  }

  setName(value) {
    this.$name.set(value);
    this.resetErrors();
  }

  setEmail(value) {
    this.$email.set(value);
    this.resetErrors();
  }

  setQuestion(value) {
    this.$question.set(value);
    this.resetErrors();
  }

  setAgree(value) {
    this.$isAgree.set(!!value);
    this.resetErrors();
  }

  submitQuestion = async () => {
    const { api } = this.store.apiStore;

    if (this.$isLoading.get() || !this.validateForm()) return;

    this.$submitError.set('');

    this.$isLoading.set(true);
    this.store.loadingStore.lock('ask');

    try {
      const name = this.$name.get().trim();
      const email = this.$email.get().trim();
      const question = this.$question.get();
      const formData = makeFormData({
        name,
        email,
        comment: question,
        customer_type: 'personal',
      });
      await api.askQuestionEn(formData);
      this.invokeAnalytics('submitFormQuestion');
      trackEvent('generate_lead', {
        lead_type: 'question',
        form_id: 'question_form',
        form_entry_point: this.entryPoint,
      });
      this.resetForm();
      this.closeModal();
      this.store.successPopupStore.open();
    } catch (e) {
      this.$submitError.set('Could not send your request. Please try again. Your details are still here.');
    } finally {
      this.store.loadingStore.unlock('ask');
      this.$isLoading.set(false);
    }
  };

  validateForm() {
    this.$nameError.set(!this.$name.get().trim());
    this.$emailError.set(!validateEmail(this.$email.get().trim()));
    this.$agreeError.set(!this.$isAgree.get());

    const isError = this.$nameError.get() || this.$emailError.get() || this.$questionError.get() || this.$agreeError.get();
    return !isError;
  }

  resetErrors() {
    this.$submitError.set('');
    this.$nameError.set(false);
    this.$emailError.set(false);
    this.$questionError.set(false);
    this.$agreeError.set(false);
  }

  resetForm() {
    this.resetErrors();
    this.$name.set('');
    this.$email.set('');
    this.$question.set('');
    this.$isAgree.set(true);
  }
}
